import { occFetch } from "~/app/api/occ/occFetch";
import { checkoutAddressUrl } from "./checkoutAddressUrl";

export const deleteAddress = (
  activeCartId: string,
  _data: object,
  id: string,
  isTemporary: boolean,
): Promise<Response> => {
  return occFetch(checkoutAddressUrl(activeCartId, `/ship/to/address/${encodeURIComponent(id)}/${isTemporary}`), {
    method: "DELETE",
  });
};
